import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import LatestOfferCard from './LatestOfferCard';

const corousal = ({offerlist}) => {
    return (
        <CarouselProvider
            naturalSlideWidth={50}
            naturalSlideHeight={17}
            totalSlides={offerlist.length}
            isPlaying={true}
        >
            <Slider>
                {
                    offerlist.length > 0 && offerlist.map((offer, index) => (
                        <Slide index={index} key={offer.offer}>
                            <LatestOfferCard offer={offer} />
                        </Slide>
                    ))
                }
            </Slider>
            <div>
                {
                    offerlist.length > 0 && (
                        <div 
                            className="offercarouselbuttons" 
                            style={{ 
                                width: '30%', 
                                margin: '0 auto', 
                                fontSize: '2em',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0 1rem'
                            }}
                        >
                            <ButtonBack>
                                <i className="bi bi-arrow-left-circle-fill" />
                            </ButtonBack>
                            <ButtonNext>
                                <i className="bi bi-arrow-right-circle-fill" />
                            </ButtonNext>
                        </div>
                    )
                }
            </div>
        </CarouselProvider>
    );
}

export default corousal;